// Customer-facing mirror of the admin discount-display modes
// (tapgoods_front_end/src/constants/discountDisplay.tsx). Drives how the
// storefront rental-items table reflects discounts.
export const DISCOUNT_DISPLAY_MODES = {
  SUMMARY_ONLY: 'summary_only',
  SUBTOTAL_STRIKE: 'subtotal_strike',
  COLUMN: 'column',
};

export const DISCOUNT_DISPLAY_DEFAULT = DISCOUNT_DISPLAY_MODES.COLUMN;
